import { render, staticRenderFns } from "./ChannelTwoCarousel.vue?vue&type=template&id=312476eb&scoped=true"
import script from "./ChannelTwoCarousel.vue?vue&type=script&lang=js"
export * from "./ChannelTwoCarousel.vue?vue&type=script&lang=js"
import style0 from "./ChannelTwoCarousel.vue?vue&type=style&index=0&id=312476eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312476eb",
  null
  
)

export default component.exports